<template>
    <div>
        <compra-direta-ferramenta-de-busca v-model="filtrosBuscaAvancada"
                                           :situacoesPossiveis="situacoesCompraDireta"
                                           :placeholderPesquisa="placeholderPesquisa"
                                           :filtros="filtrosInterno"
                                           @eventoBuscaSimples="tratarEventoBuscaSimples"
                                           @eventoRemoverFiltro="tratarEventoRemoverFiltro"
                                           @eventoBuscaAvancada="processarEventoBuscarAvancada"
                                           @updateSituacoes="(situacoes) => filtrosBuscaAvancada.situacoes = situacoes">
        </compra-direta-ferramenta-de-busca>

        <listagem-compra-direta-situacao-unica :itens="itens"
                                               :paginas="paginas"
                                               :total-itens="totalItens"
                                               :paginacao="$store.state.comprador.resultadoBuscaComprasDiretasEmAndamento.paginacao"
                                               :textoVazio="'Não há compras diretas em andamento'"
                                               :identificacaoMenu="'menuEmAndamento'"
                                               @acessarPncp="acessarPncp"
                                               @paginar="tratarEventoPaginar"
                                               @acessar="tratarEventoAcessar"/>
    </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import ListagemCompraDiretaSituacaoUnica from '@/views/pages/commons/listagem-compra-direta-situacao-unica/ListagemCompraDiretaSituacaoUnica'
import CompraDiretaFerramentaDeBusca from '@/views/pages/commons/busca-avancada/CompraDiretaFerramentaDeBusca'

export default {
    name: 'ComprasDiretasEmAndamento',
    components: {
        CompraDiretaFerramentaDeBusca,
        ListagemCompraDiretaSituacaoUnica
    },
    data() {
        return {
            filtrosInterno: this.getFiltrosCompraDiretaAndamento(),
            filtrosBuscaAvancada: this.getFiltrosBuscaAvancada(),
            itens: [],
            paginas: 0,
            totalItens: 0,
            ehBuscaAvancada: false
        }
    },
    computed: {
        placeholderPesquisa() {
            const texto = this.$t('main.commons_listagem_situacao.text').toLowerCase()
            return `Busque por: nº processo, nº consulta, objeto ou ${texto}`
        }
    },
    methods: {
        async buscar() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_COMPRA_DIRETA_EM_ANDAMENTO, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_COMPRAS_DIRETAS_EM_ANDAMENTO)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.resetFiltroBuscaAvancada()
        },
        tratarEventoPaginar(paginacao) {
            if(this.ehBuscaAvancada) {
                this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, paginacao)
                this.processarEventoBuscarAvancada()
            }else {
                this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_EM_ANDAMENTO, paginacao)
                this.buscar()
            }
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.objeto.value = valor
                this.filtrosInterno.conteudo = valor
                this.buscar()
            }
        },
        tratarEventoAcessar(id) {
            this.$store.commit(mutationTypes.SET_ROTA_ORIGEM, 'ComprasDiretasEmAndamento')
            this.$router.push({name: 'DadosGeraisVisualizacao', params: {id}})
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.resetFiltroBuscaAvancada()
            this.filtrosBuscaAvancada = this.getFiltrosBuscaAvancada()
            this.buscar()
        },
        getFiltrosCompraDiretaAndamento() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaComprasDiretasEmAndamento.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        async acessarPncp({cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp}) {
            await this.$store.dispatch(actionTypes.EXIBIR_NO_PNCP, {cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp})
        },
        getFiltrosBuscaAvancada() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaAvancadaComprasDiretas.filtros)
        },
        resetFiltroBuscaAvancada(){
            this.ehBuscaAvancada = false
            this.$store.state.comprador.resultadoBuscaAvancadaComprasDiretas.reset()

            /**
             * TODO Refatorar o funcionamento da busca avançada para se usar o esquema da busca simples
             *  e depois remove essas linhas abaixo, e também o atributo ehBuscaAvancada
             */

            const paginacaoInicial = {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            }
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_EM_ANDAMENTO, paginacaoInicial)
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, paginacaoInicial)
        },
        async processarEventoBuscarAvancada() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, this.filtrosBuscaAvancada)
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_COMPRADOR)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.ehBuscaAvancada = true
        }
    }
}
</script>

<style scoped>

</style>
